
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppFileUpload, AppImageHolder } from '@/components';
import { useLeagueTierEdit } from '@/modules/league/tier/model/edit';
import { ROUTE_NAME_LEAGUE } from '@/modules/league/router';

export default defineComponent({
    name: ROUTE_NAME_LEAGUE.TIER.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppFileUpload, AppImageHolder },
    setup() {
        const { model, v$, fetch, actions } = useLeagueTierEdit();

        onMounted(() => {
            fetch();
        });

        return { v$, model, actions, ROUTE_NAME_LEAGUE };
    }
});
